import React, { useContext, useEffect, useState } from "react";
import "./Filter_offcanvas.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Accordion, Form } from "react-bootstrap";
import Green_round_btn from "../../Common-Component/common_btn/green_round_btn/Green_round_btn";
import Successfull_Modal from "../../Common_modal/Successfull_Modal/Successfull_Modal";
import { Category } from "../../../utils/apis/Product/Product";
import Filter_btn from "../../Common-Component/common_btn/filter_btn/Filter_btn";
import Apply_round_btn from "../../Common-Component/common_btn/apply_round_btn/Apply_round_btn";
import { Context } from "../../../utils/context";

function Filter_offcanvas({
  getProduct,
  sizeSearach,
  setSizeSearch,
  sortOrder,
  category,
  show,
  handleClose,
  reset,
  setReset,
  ...props
}) {
  const sizeData = [
    { id: "S", name: "S" },
    { id: "M", name: "M" },
    { id: "L", name: "L" },
    { id: "XL", name: "XL" },
    { id: "2XL", name: "2XL" },
    { id: "3XL", name: "3XL" },
    { id: "4XL", name: "4XL" },
    { id: "5XL", name: "5XL" },
  ];
  const [modalShow, setModalShow] = React.useState(false);
  const [categoryData, setCategoryData] = useState([]);


  const { setSearch, search, setSearchTerm } = useContext(Context);

  const getCategory = async () => {
    const res = await Category();
    if (res?.success) {
      await setCategoryData(res?.data);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  const handleClick = async () => {
    await props?.handlePriceHighToLow("");
    props?.setCategory([]);
    setSizeSearch([]);
    setReset(!reset);
    handleClose();
    setSearch("");
    setSearchTerm("");

    const url = new URL(window.location.href);
    url.searchParams.delete("search");

    window.history.replaceState({}, "", url.pathname + url.search);
  };
  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;


    if (checked) {
      // add to array
      props.setCategory((prev) => [...prev, value]);
    } else {
      // remove from array
      props?.setCategory((prev) => prev.filter((v) => v !== value));
    }

    // handleClose();
  };

  const handleCheckboxChangeSize = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      // add to array
      setSizeSearch((prev) => [...prev, value]);
    } else {
      // remove from array
      setSizeSearch((prev) => prev.filter((v) => v !== value));
    }
    // handleClose();
  };


  return (
    <>
      <Offcanvas
        className="Filter_offcanvas"
        show={show}
        onHide={handleClose}
        placement="start"
        {...props}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h4 className="heading_text">Filters</h4>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="Accordion_holder">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>Price</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      <Form.Check
                        type="radio"
                        name="1"
                        id="highlow"
                        label="High To Low"
                        checked={sortOrder == "DESC"}
                        onClick={() => {
                          props?.handlePriceHighToLow("DESC");
                          // handleClose();
                        }}
                      />
                      <Form.Check
                        type="radio"
                        name="1"
                        id="lowhigh"
                        label="Low To High"
                        checked={sortOrder == "ASC"}
                        onClick={() => {
                          props?.handlePriceHighToLow("ASC");
                          // handleClose();
                        }}
                      />
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Category</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      {categoryData.map((item, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          id={item.id || `category-${index}`}
                          label={item.name}
                          value={item.id}
                          //  checked={category.includes(item.id)}
                          checked={category?.includes(String(item.id))}
                          onChange={handleCheckboxChange}
                        />
                      ))}
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Size</Accordion.Header>
                <Accordion.Body>
                  <div className="list_holder">
                    <Form>
                      {sizeData.map((item, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          id={item.id || `size-${index}`}
                          label={item.name}
                          value={item.id}
                          checked={sizeSearach?.includes(item.id)}
                          onChange={handleCheckboxChangeSize}
                        />
                      ))}
                    </Form>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
          <Apply_round_btn
            btnText="Apply"
            onClick={async () => {
              await getProduct();
              await handleClose();
              await setSearch("");
              await setSearchTerm("");

              const url = new URL(window.location.href);
              url.searchParams.delete("search");

              window.history.replaceState({}, "", url.pathname + url.search);
            }}
          />
          <Green_round_btn btnText="Reset" onClick={handleClick} />
        </Offcanvas.Body>
      </Offcanvas>

      <Successfull_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        message="Apply Successfully!"
      />
    </>
  );
}

export default Filter_offcanvas;
